export const SET_PAYMENT_RECEIPT = "SET_PAYMENT_RECEIPT";
export const SET_PREAPPROVAL_DETAILS = "SET_PREAPPROVAL_DETAILS";
export const CLEAR_PREAPPROVAL_DETAILS = "CLEAR_PREAPPROVAL_DETAILS";
export const SET_STRIPE_PAYMENT_INITIAL_RESPONSE =
	"SET_STRIPE_PAYMENT_INITIAL_RESPONSE";
export const RESET_PAYMENT_DATA = "RESET_PAYMENT_DATA";
export const SET_PAYMENT_ERRORS = "SET_PAYMENT_ERRORS";
